import React from 'react';
import './Logo.css';

interface LogoProps {
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  return (
    <h1 className={`logo ${className}`}>
      <span className="logo-gym">Gym</span>
      <span className="logo-training">Training</span>
    </h1>
  );
};
